import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { TStepItem } from '~/components/StepNavigator/types.ts';
import { styles } from '~/components/StepNavigator/styles.ts';

interface IStepNavigator {
  current: number;
  items: TStepItem[];
  id?: string;
}

export const StepNavigator = ({ current, items, id }: IStepNavigator) => {
  return (
    <Box id={id} sx={styles.stepNavigator}>
      <Stepper activeStep={current} alternativeLabel orientation="horizontal" sx={styles.stepper}>
        {items.map((item, index) => (
          <Step key={item.key || index} sx={styles.step}>
            <StepLabel
              sx={styles.stepLabel}
              slotProps={{
                stepIcon: { sx: styles.stepIcon },
              }}
            >
              {item.title}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
